/**
 * snackbarRef — Utilitário para disparar snackbars fora de componentes React.
 *
 * Problema: Redux Sagas não podem usar hooks React (useSnackbar).
 * Solução: Capturar a ref do enqueueSnackbar no SnackbarProvider
 *          e exportar funções globais que qualquer módulo pode chamar.
 *
 * Setup (em App.js):
 *   import { setSnackbarRef } from "./utils/snackbarRef";
 *   function SnackbarRefCapture() {
 *     const { enqueueSnackbar } = useSnackbar();
 *     React.useEffect(() => { setSnackbarRef(enqueueSnackbar); }, [enqueueSnackbar]);
 *     return null;
 *   }
 *   // Renderizar <SnackbarRefCapture /> dentro do <SnackbarProvider>
 *
 * Uso em sagas ou qualquer módulo JS:
 *   import { showSnackbar } from "../utils/snackbarRef";
 *   showSnackbar("Sucesso!", "success");
 *   showSnackbar("Erro!", "error");
 */

let snackbarRef = null;

export function setSnackbarRef(enqueueSnackbarFn) {
  snackbarRef = enqueueSnackbarFn;
}

export function showSnackbar(message, variant = "default", options = {}) {
  if (snackbarRef) {
    snackbarRef(message, { variant, ...options });
  } else {
    // Fallback: console para não perder feedback se ref não estiver pronta
    console.warn("[snackbarRef] Snackbar não inicializado. Mensagem:", message);
  }
}

export function showSuccess(message, options = {}) {
  showSnackbar(message, "success", options);
}

export function showError(message, options = {}) {
  showSnackbar(message, "error", options);
}

export function showWarning(message, options = {}) {
  showSnackbar(message, "warning", options);
}

export function showInfo(message, options = {}) {
  showSnackbar(message, "info", options);
}